import React, { useState } from 'react';

import { useField } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

const PasswordInput = ({ label, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field, meta] = useField({ ...props });

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    return (
        <FormControl fullWidth error={meta.touched && meta.error && meta.error.length > 0}>
            {label && <InputLabel htmlFor={props.id || props.name}>{label}</InputLabel>}
            <Input
                {...field}
                {...props}
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            <Icon>{ showPassword ? 'visibility' : 'visibility_off' }</Icon>
                        </IconButton>
                    </InputAdornment>
                }
            />
            {meta.touched && meta.error ? (
                <FormHelperText>{meta.error}</FormHelperText>
            ) : null}
        </FormControl>
    )
}

export default PasswordInput;